import step2json from '@/store/step2json';
import {
  IBaseField,
  IBaseSection,
  IEntityField,
  isBaseField,
  isBaseSection,
  isEntitySection,
  isSection,
  isTextareaOrInput,
  TField,
  TSection,
  fieldCanBeParent,
  TElement,
  isField,
  _getFields,
  getAllBaseFields,
} from '@ifr/form-questionnaire';
import { defineStore } from 'pinia';

export interface IFieldDescription {
  type: string;
  name: string;
  sectionName?: string;
}

export type Journal = Map<string, IFieldDescription>;

interface FormBuilderState0 {
  journalId: Journal;
  journalFieldsId: Journal;
  selectedSourceIds: Set<string>;
  json: TSection[];
}

export interface PayloadSetField {
  data: TElement;
  i: number;
  j: number;
}

export interface IPayloadUpdateChildrenByParentId {
  parentId: string;
  callback: (item: IBaseField | IBaseSection | IEntityField) => void;
}

export const useFormBuilderStore = defineStore('formBuilder', {
  state: (): FormBuilderState0 => ({
    journalId: new Map(),
    journalFieldsId: new Map(),
    selectedSourceIds: new Set(),
    json: step2json.slice(),
  }),

  actions: {
    setJournal(field: TField, sectionName: string) {
      this.journalId.set(field.id, {
        type: field.name,
        name: field.label,
        sectionName,
      });
    },

    setJournalFields(field: IBaseField | IBaseSection) {
      if (isTextareaOrInput(field)) {
        this.journalFieldsId.set(field.id, {
          type: field.type,
          name: field.label,
        });
      }
    },

    setSelectedSourceIds(id: string) {
      this.selectedSourceIds.add(id);
    },

    delSelectedSourceIds(id: string) {
      this.selectedSourceIds.delete(id);
    },

    clearJournal() {
      this.journalId.clear();
      this.journalFieldsId.clear();
    },

    delJournal(id: string) {
      this.journalId.delete(id);
      this.journalFieldsId.delete(id);
    },

    setJson(quest: TSection[] = []) {
      this.json = quest;
    },

    setField({ data, i = 0, j = 0 }: PayloadSetField) {
      const section: TSection = this.json[i];
      if (isSection(section)) {
        if (section.fields) {
          //@ts-ignore
          section.fields.splice(j, 1, data);
        } else if (isEntitySection(section) && section.blocks) {
          //@ts-ignore
          section.blocks[0].fields.splice(j, 1, data);
        }
      } else {
        throw new Error('Изменяемое значение не находится в разделе');
      }
    },

    updateChildrenByParentId({ parentId, callback }: IPayloadUpdateChildrenByParentId) {
      this.json.forEach((element) => {
        const children: (IBaseField | IBaseSection | IEntityField)[] = _getFields(element).filter(
          (field) => isBaseField(field) && field.parent.id && field.parent.id == parentId,
        ) as IBaseField[];

        if (isBaseSection(element) && element.parent && element.parent.id && element.parent.id == parentId) {
          children.push(element);
        }

        children.forEach(callback);
      });
    },

    updateChildrenBySourceId({ parentId: sourceId, callback }: IPayloadUpdateChildrenByParentId) {
      getAllBaseFields(this.json)
        .filter((field) => field.idSourceField === sourceId)
        .forEach(callback);
    },

    setJournalAllFields(json: TSection[]) {
      getAllBaseFields(json || this.json).forEach((field) => {
        this.setJournalFields(field);
      });
    },

    addJournal(field: IBaseField | IBaseSection, sectionName = '') {
      if (isField(field) && field.id && fieldCanBeParent(field)) {
        this.setJournal(field, sectionName);
      }
    },
  },
});

export default useFormBuilderStore;
